export default function isBaseModel(model){

    return model.modelId === model.parentId;
}